import { getCurrencySymbol } from "@components/FairPayStatusShort/formatFairPayStatusAmount";
import { formatPayRangeAmount } from "@components/utils/formatPayRangeAmount";

const PAY_BASIS_LABEL = { HOURLY: "Hourly", MONTHLY: "Monthly", ANNUAL: "Annual" };

function toAmount(value) {
  if (value == null || value === "") return null;
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
}

/** `{ min, max, code, payBasis }` for a record carrying a full pay range, else null. */
function resolvePayRange(record) {
  const min = toAmount(record?.minAmount);
  const max = toAmount(record?.maxAmount);
  if (min === null || max === null) return null;
  return {
    min,
    max,
    code: record.currency || "USD",
    payBasis: record.payBasis ? String(record.payBasis) : "",
  };
}

function formatFullAmount(amount) {
  const digits = Number.isInteger(amount) ? 0 : 2;
  return amount.toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

/** Bar suffix, e.g. "$50K–$80K". Empty when min or max is missing, so a bar never shows "$0K". */
export function formatPayRangeShort(record) {
  const range = resolvePayRange(record);
  if (!range) return "";
  const symbol = getCurrencySymbol(range.code);
  return `${symbol}${formatPayRangeAmount(range.min)}–${symbol}${formatPayRangeAmount(range.max)}`;
}

/** Tooltip line, e.g. "Range: $50,000 – $80,000 USD / Annual". Empty when min or max is missing. */
export function formatPayRangeLine(record) {
  const range = resolvePayRange(record);
  if (!range) return "";
  const symbol = getCurrencySymbol(range.code);
  const basis = PAY_BASIS_LABEL[range.payBasis.toUpperCase()] || range.payBasis;
  const amounts = `${symbol}${formatFullAmount(range.min)} – ${symbol}${formatFullAmount(range.max)}`;
  return `Range: ${amounts} ${range.code}${basis ? ` / ${basis}` : ""}`;
}
